import "../../stylesheets/corporate/index.scss"

import { Turbo } from "@hotwired/turbo-rails"
window.Turbo = Turbo;

